/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { FxGamesLibWebPlatformDataOptionsPlatformDataOptionsVkontakteCom } from './FxGamesLibWebPlatformDataOptionsPlatformDataOptionsVkontakteCom';
import {
    instanceOfFxGamesLibWebPlatformDataOptionsPlatformDataOptionsVkontakteCom,
    FxGamesLibWebPlatformDataOptionsPlatformDataOptionsVkontakteComFromJSON,
    FxGamesLibWebPlatformDataOptionsPlatformDataOptionsVkontakteComFromJSONTyped,
    FxGamesLibWebPlatformDataOptionsPlatformDataOptionsVkontakteComToJSON,
} from './FxGamesLibWebPlatformDataOptionsPlatformDataOptionsVkontakteCom';

/**
 * @type FxGamesLibWebPlatformDataOptionsVkontakteCom
 * 
 * @export
 */
export type FxGamesLibWebPlatformDataOptionsVkontakteCom = FxGamesLibWebPlatformDataOptionsPlatformDataOptionsVkontakteCom;

export function FxGamesLibWebPlatformDataOptionsVkontakteComFromJSON(json: any): FxGamesLibWebPlatformDataOptionsVkontakteCom {
    return FxGamesLibWebPlatformDataOptionsVkontakteComFromJSONTyped(json, false);
}

export function FxGamesLibWebPlatformDataOptionsVkontakteComFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxGamesLibWebPlatformDataOptionsVkontakteCom {
    if (json == null) {
        return json;
    }
    if (instanceOfFxGamesLibWebPlatformDataOptionsPlatformDataOptionsVkontakteCom(json)) {
        return FxGamesLibWebPlatformDataOptionsPlatformDataOptionsVkontakteComFromJSONTyped(json, true);
    }

    return {} as any;
}

export function FxGamesLibWebPlatformDataOptionsVkontakteComToJSON(json: any): any {
    return FxGamesLibWebPlatformDataOptionsVkontakteComToJSONTyped(json, false);
}

export function FxGamesLibWebPlatformDataOptionsVkontakteComToJSONTyped(value?: FxGamesLibWebPlatformDataOptionsVkontakteCom | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    if (instanceOfFxGamesLibWebPlatformDataOptionsPlatformDataOptionsVkontakteCom(value)) {
        return FxGamesLibWebPlatformDataOptionsPlatformDataOptionsVkontakteComToJSON(value as FxGamesLibWebPlatformDataOptionsPlatformDataOptionsVkontakteCom);
    }

    return {};
}

